<template>
  <div class="wrapper">
    <Headers ref="headers" />
    <div class="mainPage1">
      <section class="favorite">
        <div class="container">
          <div class="container__elem container__elem--12">
            <h1 class="favorite__title">Избранные мероприятия</h1>
            <div class="favorite__wrap">
              <div v-if="events && events.length > 0" class="favorite__inner" ref="eventsInner">
                <div class="favorite__item" v-for="(event, index) in events" :key="index" @click="fetchEvent(event.id)">
                  <div class="favorite__item-poster">
                    <div class="favorite__item-fulltime">
                      <p class="favorite__item-date" v-html="formatShortDate(event.startTime)"></p>
                      <p class="favorite__item-time">
                        {{ formatDateTime(event.startTime, event.finishTime) }}
                        <sup v-if="getDayDifference(event.startTime, event.finishTime)">
                          {{ getDayDifference(event.startTime, event.finishTime) }}
                        </sup>
                      </p>
                    </div>

                    <img :src="`/api/pis/v1/images/posters/${event.posterName}`" alt="" class="favorite__item-img">
                  </div>
                  <div class="favorite__item-content">
                    <p class="favorite__item-title">{{ event.shortTitle }}</p>
                    <p class="favorite__item-text">{{ event.shortDescription }}</p>
                    <div class="favorite__item-point">
                      <i>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9 16.5002C13.1421 16.5002 16.5 14.9892 16.5 13.1252C16.5 12.1752 15.6278 11.3169 14.2241 10.7036C13.3675 12.2755 12.0613 13.6304 10.4021 14.3394C9.51032 14.7205 8.48968 14.7205 7.59786 14.3394C5.93871 13.6304 4.6325 12.2755 3.77594 10.7036C2.37221 11.3169 1.5 12.1752 1.5 13.1252C1.5 14.9892 4.85786 16.5002 9 16.5002Z"
                            fill="#4BB85A" />
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M3.75 6.38598C3.75 3.68753 6.10051 1.5 9 1.5C11.8995 1.5 14.25 3.68753 14.25 6.38598C14.25 9.06328 12.5744 12.1874 9.96005 13.3047C9.35061 13.5651 8.64939 13.5651 8.03995 13.3047C5.42562 12.1874 3.75 9.06328 3.75 6.38598ZM9 8.25C9.82843 8.25 10.5 7.57843 10.5 6.75C10.5 5.92157 9.82843 5.25 9 5.25C8.17157 5.25 7.5 5.92157 7.5 6.75C7.5 7.57843 8.17157 8.25 9 8.25Z"
                            fill="#4BB85A" />
                        </svg>


                      </i>
                      <p v-if="event.addr" class="favorite__item-addr">{{ event.addr }}</p>
                      <p v-else class="favorite__item-addr">Адрес мероприятия</p>
                    </div>
                    <MarkersPanel :markers="event.markers" />
                    <div class="favorite__item-fav" :class="{ active: true }" @click="deleteFav($event, event)">
                      <i>
                        <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M3.74957 1.44946C2.64357 1.95502 1.83333 3.15749 1.83333 4.5914C1.83333 6.05633 2.43281 7.18549 3.29219 8.15318C4.00048 8.95074 4.85789 9.61175 5.69408 10.2564C5.89268 10.4095 6.09009 10.5617 6.28403 10.7146C6.63471 10.991 6.94754 11.2337 7.24907 11.4099C7.55076 11.5862 7.79359 11.6667 8 11.6667C8.2064 11.6667 8.44923 11.5862 8.75092 11.4099C9.05245 11.2337 9.36528 10.991 9.71596 10.7146C9.90989 10.5617 10.1073 10.4095 10.3059 10.2564C11.1421 9.61175 11.9995 8.95074 12.7078 8.15318C13.5672 7.18549 14.1667 6.05633 14.1667 4.5914C14.1667 3.15749 13.3564 1.95502 12.2504 1.44946C11.1759 0.958319 9.73222 1.08839 8.36024 2.51382C8.26598 2.61175 8.13592 2.66709 8 2.66709C7.86407 2.66709 7.73401 2.61175 7.63975 2.51382C6.26777 1.08839 4.82404 0.958319 3.74957 1.44946ZM8 1.47255C6.45863 0.0934962 4.73264 -0.0994186 3.33384 0.539976C1.85647 1.21528 0.833328 2.78336 0.833328 4.5914C0.833328 6.36842 1.57366 7.72404 2.54447 8.81721C3.32191 9.69263 4.27348 10.4253 5.11388 11.0724C5.30439 11.2191 5.48918 11.3614 5.66494 11.4999C6.00643 11.7691 6.37302 12.0562 6.74454 12.2733C7.1159 12.4903 7.53973 12.6667 8 12.6667C8.46026 12.6667 8.88409 12.4903 9.25545 12.2733C9.62697 12.0562 9.99356 11.7691 10.335 11.4999C10.5108 11.3614 10.6956 11.2191 10.8861 11.0724C11.7265 10.4253 12.6781 9.69263 13.4555 8.81721C14.4263 7.72404 15.1667 6.36842 15.1667 4.5914C15.1667 2.78336 14.1435 1.21528 12.6662 0.539976C11.2674 -0.0994186 9.54137 0.0934962 8 1.47255Z"
                            fill="#4BB85A" />
                        </svg>

                      </i>
                      <p>{{ event.favoriteCount }}</p>
                    </div>
                    <img :src="event.organizer && event.organizer.logo`/api/pis/v1/images/icons/${event.organizer.logo}`"
                      alt="" class="favorite__item-logo" style="background-color: gray;"
                       />

                  </div>
                </div>
              </div>
              <div v-else class="favorite__placeholder">
                <div class="favorite__placeholder-inner">
                  <p v-if="!loading" class="favorite__placeholder-text">У вас нет избранных мероприятий.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Footers />
  </div>
  <transition>
  <div v-if="isPopupVisible" class="popup" ref="popup">
    <div class="event__close" @click="closePopup">
      <i>
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.5 1.5L19.5 19.5M1.5 19.5L19.5 1.5" stroke="#333333" stroke-width="1.5" />
        </svg>
      </i>
    </div>
    <div v-if="isLinkCopied" class="event__copy-message">Ссылка скопирована!</div>
    <div class="event">
      <div class="event__inner">
        <div class="event__content">
          <h3 v-if="decktopVisible()" class="event__title">{{ selectedEvent.title }}</h3>
          <div v-if="decktopVisible()" class="event__dateTime">
            <i>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.5 8C0.5 4.46447 0.5 2.6967 1.59835 1.59835C2.6967 0.5 4.46447 0.5 8 0.5C11.5355 0.5 13.3033 0.5 14.4017 1.59835C15.5 2.6967 15.5 4.46447 15.5 8C15.5 11.5355 15.5 13.3033 14.4017 14.4017C13.3033 15.5 11.5355 15.5 8 15.5C4.46447 15.5 2.6967 15.5 1.59835 14.4017C0.5 13.3033 0.5 11.5355 0.5 8Z"
                  fill="#4BB85A" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8 4.4375C8.31066 4.4375 8.5625 4.68934 8.5625 5V7.767L10.2727 9.47725C10.4924 9.69692 10.4924 10.0531 10.2727 10.2727C10.0531 10.4924 9.69692 10.4924 9.47725 10.2727L7.60225 8.39775C7.49676 8.29226 7.4375 8.14918 7.4375 8V5C7.4375 4.68934 7.68934 4.4375 8 4.4375Z"
                  fill="white" />
              </svg>

            </i>
            <p>{{ formatDateTimeForPopup(selectedEvent.startTime, selectedEvent.finishTime).time }}</p>
          </div>
          <div v-if="decktopVisible()" class="event__dateTime">
            <i>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.8125 0.875C4.8125 0.56434 4.56066 0.3125 4.25 0.3125C3.93934 0.3125 3.6875 0.56434 3.6875 0.875V2.05944C2.608 2.14588 1.89933 2.35803 1.37868 2.87868C0.858031 3.39933 0.645885 4.108 0.559443 5.1875H15.4406C15.3541 4.108 15.142 3.39933 14.6213 2.87868C14.1007 2.35803 13.392 2.14588 12.3125 2.05944V0.875C12.3125 0.56434 12.0607 0.3125 11.75 0.3125C11.4393 0.3125 11.1875 0.56434 11.1875 0.875V2.00968C10.6886 2 10.1293 2 9.5 2H6.5C5.87072 2 5.31145 2 4.8125 2.00968V0.875Z"
                  fill="#4BB85A" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M0.5 8C0.5 7.37072 0.5 6.81145 0.509677 6.3125H15.4903C15.5 6.81145 15.5 7.37072 15.5 8V9.5C15.5 12.3284 15.5 13.7426 14.6213 14.6213C13.7426 15.5 12.3284 15.5 9.5 15.5H6.5C3.67157 15.5 2.25736 15.5 1.37868 14.6213C0.5 13.7426 0.5 12.3284 0.5 9.5V8ZM11.75 9.5C12.1642 9.5 12.5 9.16421 12.5 8.75C12.5 8.33579 12.1642 8 11.75 8C11.3358 8 11 8.33579 11 8.75C11 9.16421 11.3358 9.5 11.75 9.5ZM11.75 12.5C12.1642 12.5 12.5 12.1642 12.5 11.75C12.5 11.3358 12.1642 11 11.75 11C11.3358 11 11 11.3358 11 11.75C11 12.1642 11.3358 12.5 11.75 12.5ZM8.75 8.75C8.75 9.16421 8.41421 9.5 8 9.5C7.58579 9.5 7.25 9.16421 7.25 8.75C7.25 8.33579 7.58579 8 8 8C8.41421 8 8.75 8.33579 8.75 8.75ZM8.75 11.75C8.75 12.1642 8.41421 12.5 8 12.5C7.58579 12.5 7.25 12.1642 7.25 11.75C7.25 11.3358 7.58579 11 8 11C8.41421 11 8.75 11.3358 8.75 11.75ZM4.25 9.5C4.66421 9.5 5 9.16421 5 8.75C5 8.33579 4.66421 8 4.25 8C3.83579 8 3.5 8.33579 3.5 8.75C3.5 9.16421 3.83579 9.5 4.25 9.5ZM4.25 12.5C4.66421 12.5 5 12.1642 5 11.75C5 11.3358 4.66421 11 4.25 11C3.83579 11 3.5 11.3358 3.5 11.75C3.5 12.1642 3.83579 12.5 4.25 12.5Z"
                  fill="#4BB85A" />
              </svg>

            </i>
            <p>{{ formatDateTimeForPopup(selectedEvent.startTime, selectedEvent.finishTime).date }}</p>
          </div>

          <h2 class="event__info-name">Организатор</h2>
          <div class="event__org">
            <img class="event__org-icon" :src="`/api/pis/v1/images/icons/${selectedEvent.organizer.logo}`" alt=""
              @click="openOrganizerModal($event, selectedEvent.organizer.id)">
            <p class="event__org-text">{{ selectedEvent.organizer.title }}</p>
          </div>
          <h2 class="event__info-name">Адрес проведения мероприятия</h2>
          <div class="event__address">
            <i>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 22.0003C17.5228 22.0003 22 19.9856 22 17.5003C22 16.2337 20.837 15.0892 18.9654 14.2715C17.8233 16.3673 16.0817 18.1738 13.8695 19.1192C12.6804 19.6274 11.3196 19.6274 10.1305 19.1192C7.91828 18.1738 6.17666 16.3673 5.03458 14.2715C3.16295 15.0892 2 16.2337 2 17.5003C2 19.9856 6.47715 22.0003 12 22.0003Z"
                  fill="#4BB85A" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M5 8.51464C5 4.9167 8.13401 2 12 2C15.866 2 19 4.9167 19 8.51464C19 12.0844 16.7658 16.2499 13.2801 17.7396C12.4675 18.0868 11.5325 18.0868 10.7199 17.7396C7.23416 16.2499 5 12.0844 5 8.51464ZM12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11Z"
                  fill="#4BB85A" />
              </svg>

            </i>
            <p>{{ selectedEvent.addr }}</p>
          </div>
          <button :class="{ active: eventMapShow }" class="event__map-btn" @click="eventMapShow = !eventMapShow">
            <p>Показать карту</p>
            <i>
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.19995 4.56665L4.99995 1.36665L1.79995 4.56665" stroke="#4BB85A" stroke-width="1.5"
                  stroke-linecap="square" />
              </svg>

            </i>
          </button>
          <div class="event__map" :class="{ show: eventMapShow }" ref="mapContainer" style="position: relative;">
          </div>
          <h2 class="event__info-name">Описание мероприятия</h2>
          <p class="event__info-text" v-html="formattedDescr(selectedEvent.description)"></p>
          <div v-if="selectedEvent.link" class="event__info-source">
            <p>Источник:</p>
            <a :href="selectedEvent.link">{{ selectedEvent.link }}</a>
          </div>
        </div>
        <div class="event__side">
          <div class="event__poster-wrap" :style="{ backgroundColor: '#' + selectedEvent.color }">
            <img class="event__poster" v-if="selectedEvent.rect !== null" :id="`imgCor-${selectedEvent.id}`"
              :src="getImgCropCon(selectedEvent)" alt="">
            <img class="event__poster" v-else :src="getImgUrl(selectedEvent.posterName)" alt="">
            <div class="event__poster-block">
              <div class="event__fav active" :class="{ active: selectedEvent.favorite }"
                @click="deleteFav($event, selectedEvent)">
                <i>
                  <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M3.74957 1.44946C2.64357 1.95502 1.83333 3.15749 1.83333 4.5914C1.83333 6.05633 2.43281 7.18549 3.29219 8.15318C4.00048 8.95074 4.85789 9.61175 5.69408 10.2564C5.89268 10.4095 6.09009 10.5617 6.28403 10.7146C6.63471 10.991 6.94754 11.2337 7.24907 11.4099C7.55076 11.5862 7.79359 11.6667 8 11.6667C8.2064 11.6667 8.44923 11.5862 8.75092 11.4099C9.05245 11.2337 9.36528 10.991 9.71596 10.7146C9.90989 10.5617 10.1073 10.4095 10.3059 10.2564C11.1421 9.61175 11.9995 8.95074 12.7078 8.15318C13.5672 7.18549 14.1667 6.05633 14.1667 4.5914C14.1667 3.15749 13.3564 1.95502 12.2504 1.44946C11.1759 0.958319 9.73222 1.08839 8.36024 2.51382C8.26598 2.61175 8.13592 2.66709 8 2.66709C7.86407 2.66709 7.73401 2.61175 7.63975 2.51382C6.26777 1.08839 4.82404 0.958319 3.74957 1.44946ZM8 1.47255C6.45863 0.0934962 4.73264 -0.0994186 3.33384 0.539976C1.85647 1.21528 0.833328 2.78336 0.833328 4.5914C0.833328 6.36842 1.57366 7.72404 2.54447 8.81721C3.32191 9.69263 4.27348 10.4253 5.11388 11.0724C5.30439 11.2191 5.48918 11.3614 5.66494 11.4999C6.00643 11.7691 6.37302 12.0562 6.74454 12.2733C7.1159 12.4903 7.53973 12.6667 8 12.6667C8.46026 12.6667 8.88409 12.4903 9.25545 12.2733C9.62697 12.0562 9.99356 11.7691 10.335 11.4999C10.5108 11.3614 10.6956 11.2191 10.8861 11.0724C11.7265 10.4253 12.6781 9.69263 13.4555 8.81721C14.4263 7.72404 15.1667 6.36842 15.1667 4.5914C15.1667 2.78336 14.1435 1.21528 12.6662 0.539976C11.2674 -0.0994186 9.54137 0.0934962 8 1.47255Z"
                      fill="#4BB85A" />
                  </svg>

                </i>
                <p>{{ selectedEvent.favoriteCount }}</p>
              </div>
              <div class="event__link" @click="shareEvent">
                <i>
                  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M6.72004 0.746026C6.72223 1.0049 6.51415 1.21654 6.25528 1.21873C5.18678 1.22779 4.39931 1.26254 3.78926 1.38203C3.1923 1.49897 2.79989 1.69083 2.49699 1.99373C2.14083 2.34988 1.93646 2.83174 1.82901 3.63096C1.71975 4.44367 1.71875 5.5116 1.71875 6.99837C1.71875 8.48515 1.71975 9.55307 1.82901 10.3658C1.93646 11.165 2.14083 11.6469 2.49699 12.003C2.85314 12.3592 3.335 12.5635 4.13422 12.671C4.94693 12.7803 6.01486 12.7813 7.50163 12.7813C8.98841 12.7813 10.0563 12.7803 10.869 12.671C11.6683 12.5635 12.1501 12.3592 12.5063 12.003C12.8092 11.7001 13.001 11.3077 13.118 10.7107C13.2375 10.1007 13.2722 9.31322 13.2813 8.24472C13.2835 7.98585 13.4951 7.77777 13.754 7.77996C14.0128 7.78216 14.2209 7.9938 14.2187 8.25267C14.2097 9.31793 14.1762 10.1855 14.038 10.891C13.8972 11.6095 13.642 12.1931 13.1692 12.6659C12.6098 13.2253 11.8971 13.4787 10.994 13.6001C10.1116 13.7188 8.98062 13.7188 7.53749 13.7188H7.46577C6.02264 13.7188 4.8917 13.7188 4.0093 13.6001C3.10612 13.4787 2.39345 13.2253 1.83407 12.6659C1.2747 12.1066 1.0213 11.3939 0.899871 10.4907C0.781236 9.6083 0.781242 8.47736 0.78125 7.03423V6.96251C0.781242 5.51938 0.781236 4.38844 0.899871 3.50604C1.0213 2.60286 1.2747 1.89019 1.83407 1.33081C2.30689 0.857997 2.89049 0.602768 3.60904 0.462017C4.31451 0.323831 5.18207 0.290299 6.24733 0.281267C6.5062 0.279072 6.71784 0.487152 6.72004 0.746026ZM10.2935 0.418544C10.4766 0.235486 10.7734 0.235486 10.9565 0.418544L14.0815 3.54354C14.2645 3.7266 14.2645 4.0234 14.0815 4.20646L10.9565 7.33146C10.7734 7.51452 10.4766 7.51452 10.2935 7.33146C10.1105 7.1484 10.1105 6.8516 10.2935 6.66854L12.6183 4.34375H8.75C7.78033 4.34375 7.208 4.81688 7.00753 5.01833L6.88742 5.13902L6.76833 5.25752C6.56688 5.45799 6.09375 6.03033 6.09375 7V8.875C6.09375 9.13388 5.88388 9.34375 5.625 9.34375C5.36612 9.34375 5.15625 9.13388 5.15625 8.875V7C5.15625 5.69764 5.79814 4.90039 6.10703 4.59301C6.10703 4.59301 6.10703 4.59301 6.10703 4.59301L6.22611 4.4745L6.343 4.35703C6.65039 4.04815 7.44763 3.40625 8.75 3.40625H12.6183L10.2935 1.08146C10.1105 0.898398 10.1105 0.601602 10.2935 0.418544Z"
                      fill="#333333" />
                  </svg>


                </i>
              </div>
            </div>
          </div>
          <div class="event__side-info">
            <h3 v-if="!decktopVisible()" class="event__title">{{ selectedEvent.title }}</h3>
            <div v-if="!decktopVisible()" class="event__dateTime">
              <i>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0.5 8C0.5 4.46447 0.5 2.6967 1.59835 1.59835C2.6967 0.5 4.46447 0.5 8 0.5C11.5355 0.5 13.3033 0.5 14.4017 1.59835C15.5 2.6967 15.5 4.46447 15.5 8C15.5 11.5355 15.5 13.3033 14.4017 14.4017C13.3033 15.5 11.5355 15.5 8 15.5C4.46447 15.5 2.6967 15.5 1.59835 14.4017C0.5 13.3033 0.5 11.5355 0.5 8Z"
                    fill="#4BB85A" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8 4.4375C8.31066 4.4375 8.5625 4.68934 8.5625 5V7.767L10.2727 9.47725C10.4924 9.69692 10.4924 10.0531 10.2727 10.2727C10.0531 10.4924 9.69692 10.4924 9.47725 10.2727L7.60225 8.39775C7.49676 8.29226 7.4375 8.14918 7.4375 8V5C7.4375 4.68934 7.68934 4.4375 8 4.4375Z"
                    fill="white" />
                </svg>

              </i>
              <p>{{ formatDateTimeForPopup(selectedEvent.startTime, selectedEvent.finishTime).time }}</p>
            </div>
            <div v-if="!decktopVisible()" class="event__dateTime">
              <i>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.8125 0.875C4.8125 0.56434 4.56066 0.3125 4.25 0.3125C3.93934 0.3125 3.6875 0.56434 3.6875 0.875V2.05944C2.608 2.14588 1.89933 2.35803 1.37868 2.87868C0.858031 3.39933 0.645885 4.108 0.559443 5.1875H15.4406C15.3541 4.108 15.142 3.39933 14.6213 2.87868C14.1007 2.35803 13.392 2.14588 12.3125 2.05944V0.875C12.3125 0.56434 12.0607 0.3125 11.75 0.3125C11.4393 0.3125 11.1875 0.56434 11.1875 0.875V2.00968C10.6886 2 10.1293 2 9.5 2H6.5C5.87072 2 5.31145 2 4.8125 2.00968V0.875Z"
                    fill="#4BB85A" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M0.5 8C0.5 7.37072 0.5 6.81145 0.509677 6.3125H15.4903C15.5 6.81145 15.5 7.37072 15.5 8V9.5C15.5 12.3284 15.5 13.7426 14.6213 14.6213C13.7426 15.5 12.3284 15.5 9.5 15.5H6.5C3.67157 15.5 2.25736 15.5 1.37868 14.6213C0.5 13.7426 0.5 12.3284 0.5 9.5V8ZM11.75 9.5C12.1642 9.5 12.5 9.16421 12.5 8.75C12.5 8.33579 12.1642 8 11.75 8C11.3358 8 11 8.33579 11 8.75C11 9.16421 11.3358 9.5 11.75 9.5ZM11.75 12.5C12.1642 12.5 12.5 12.1642 12.5 11.75C12.5 11.3358 12.1642 11 11.75 11C11.3358 11 11 11.3358 11 11.75C11 12.1642 11.3358 12.5 11.75 12.5ZM8.75 8.75C8.75 9.16421 8.41421 9.5 8 9.5C7.58579 9.5 7.25 9.16421 7.25 8.75C7.25 8.33579 7.58579 8 8 8C8.41421 8 8.75 8.33579 8.75 8.75ZM8.75 11.75C8.75 12.1642 8.41421 12.5 8 12.5C7.58579 12.5 7.25 12.1642 7.25 11.75C7.25 11.3358 7.58579 11 8 11C8.41421 11 8.75 11.3358 8.75 11.75ZM4.25 9.5C4.66421 9.5 5 9.16421 5 8.75C5 8.33579 4.66421 8 4.25 8C3.83579 8 3.5 8.33579 3.5 8.75C3.5 9.16421 3.83579 9.5 4.25 9.5ZM4.25 12.5C4.66421 12.5 5 12.1642 5 11.75C5 11.3358 4.66421 11 4.25 11C3.83579 11 3.5 11.3358 3.5 11.75C3.5 12.1642 3.83579 12.5 4.25 12.5Z"
                    fill="#4BB85A" />
                </svg>

              </i>
              <p>{{ formatDateTimeForPopup(selectedEvent.startTime, selectedEvent.finishTime).date }}</p>
            </div>


            <div v-for="(block, index) in selectedEvent.blocks" :key="index" class="event__block">
              <!-- Вывод информации о блоке -->
              <div v-for="(info, idx) in block.info" :key="idx" class="event__info">
                <template v-if="info.type === 'message'">
                  <p>{{ info.message }}</p>
                </template>
                <template v-if="info.type === 'cost'">
                  <p class="event__block-price">Цена</p>
                  <p class="event__block-cost">{{ info.cost }}</p>
                </template>
                <template v-if="info.type === 'label_count'">
                  <div class="event__block-flex">
                    <p>{{ info.label }}</p>
                    <p class="event__block-count">{{ info.count }}</p>
                  </div>
                </template>
              </div>

              <!-- Вывод кнопок взаимодействия -->
              <div v-if="block.interact" class="event__interact">
                <template v-if="block.interact.type === 'button'">
                  <button @click="handleAction(block.interact.action)">
                    {{ block.interact.label }}
                  </button>
                </template>

                <template v-if="block.interact.type === 'button_count'">
                  <div class="event__counter">
                    <button @click="updateCount(block, -1)" :disabled="block.interact.currentCount <= 0">
                      <i>
                        <svg width="8" height="1" viewBox="0 0 8 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.5 0.5H7.5" stroke="#333333" />
                        </svg>
                      </i>
                    </button>
                    <p class="event__block-count">{{ count || 1 }}</p>
                    <button @click="updateCount(block, 1)"
                      :disabled="block.interact.currentCount >= block.interact.maxCount">
                      <i>
                        <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4 0V7M0.5 3.5H7.5" stroke="#333333" />
                        </svg>
                      </i>
                    </button>
                  </div>
                  <button @click="handleAction(block.interact.action)" class="event__block-reserve">
                    {{ block.interact.label }}
                  </button>
                  <!-- Сообщение об успешной или неудачной резервировании -->
                  <p v-if="reservationStatus"
                    :class="{ 'success-message': reservationStatus.success, 'error-message': !reservationStatus.success }">
                    {{ reservationStatus.message }}
                  </p>
                </template>
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>

  </div>
  </transition>
  <OrganizerModal v-if="isModalVisible" :organizerId="selectedOrganizerId" @close="isModalVisible = false" />
</template>

<script>

import axios from 'axios'
import Headers from '@/components/Headers.vue'
import Footers from '@/components/Footers.vue'
import metka3 from '@/assets/img/metka3.png';
axios.defaults.headers.common['X-API-KEY'] = 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1';
import OrganizerModal from '@/components/OrganizerModal.vue';
import MarkersPanel from '@/components/MarkersPanel.vue';



export default {
  name: 'FavoriteEventsView',
  components: {
    Headers,
    Footers,
    OrganizerModal,
    MarkersPanel
  },
  data() {
    return {
      events: [],
      isPopupVisible: false,
      loading: false,
      isModalVisible: false,
      selectedOrganizerId: null,
      isLinkCopied: false,
      eventMapShow: false,
      count: 1, // Переменная для хранения сообщения об ошибке
      reservationStatus: null // Для хранения статуса сообщения
    };
  },
  methods: {
    decktopVisible() {
      if (window.innerWidth < 1025) {
        return false;
      } else {
        return true;
      }
    },
    handleAction(action) {
      if (action.type === 'phone') {
        window.location.href = `tel:${action.phone}`;
      } else if (action.type === 'url') {
        let url = action.url;

        // Проверим, начинается ли url с протокола. Если нет, добавим https://
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
          url = 'https://' + url;
        }

        window.open(url, '_blank');

      } else if (action.type === 'post') {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo'));
        if (userInfo) {
          const requestBody = {
            eventId: this.selectedEvent.id, // предполагаем, что eventId есть в interact
            reservCount: this.count // предполагаем, что reservCount есть в interact
          };

          // Конфигурация для запроса
          const config = {
            headers: {
              'Content-Type': 'application/json'
            }
          };

          // Выполнение POST запроса с async/await
          axios.post('/api/pis/v1/for_account/reserv', requestBody, config)
            .then(response => {
              // Обработка успешного ответа
              if (response.status === 200) {
                this.reservationStatus = {
                  success: true,
                  message: 'Резервация успешна!'
                };
              } else {
                this.reservationStatus = {
                  success: false,
                  message: `Ошибка: ${response.data.message || 'Неизвестная ошибка'}`
                };
              }
            })
            .catch(error => {
              // Обработка ошибок
              this.reservationStatus = {
                success: false,
                message: `Ошибка: ${error.response?.data?.message || error.message}`
              };
            });

          // Скрыть сообщение через 5 секунд
          setTimeout(() => {
            this.reservationStatus = null;
          }, 5000);
        } else {
          this.showLoginModal = true;
        }
      }
    },
    updateCount(block, delta) {
      if (!block.interact.currentCount) block.interact.currentCount = 1;
      this.count = block.interact.currentCount + delta;
      if (this.count >= 1 && this.count <= block.interact.maxCount) {
        block.interact.currentCount = this.count;
      }
    },
    openOrganizerModal(event, organizerId) {
      if (organizerId) {
        event.stopPropagation();
        this.selectedOrganizerId = organizerId;  // Сохраняем ID организатора
        this.isModalVisible = true;              // Отображаем модальное окно
      }
    },
    async fetchEvent(id) {
      const devParam = window.innerWidth > 1023 ? 'd' : 'm';
      const viewParam = 'c';

      const queryParams = new URLSearchParams({
        dev: devParam,
        view: viewParam,
      });

      const apiUrl = `/api/pis/v1/events/event/${id}?${queryParams}`;
      axios.get(apiUrl)
        .then(response => {
          this.openPopup(response.data);
        })
        .catch(error => {
          document.querySelector('html').classList.remove('animShowPopup');
          setTimeout(() => {
            document.querySelector('html').classList.remove('showPopup');
          }, 500);
        });
    },

    openPopup(event) {
      if (event) {
        this.selectedEvent = event;
        this.isPopupVisible = true;
        this.scrollPosition = window.scrollY;
        document.querySelector('html').classList.add('showPopup');
        setTimeout(() => {
          document.querySelector('html').classList.add('animShowPopup');
          this.initMap();
        }, 10);
      }
    },
    async fetchEvents() {
      // Получаем элемент, к которому нужно добавить класс
      const mainPage = document.querySelector('.mainPage1');

      // Добавляем класс до того, как начнется загрузка
      const loadingTimeout = setTimeout(() => {
        mainPage.classList.add('load');
      }, 1000); // Таймер срабатывает через 2 секунды

      this.events = null;

      try {
        const response = await axios.get("/api/pis/v1/for_account/favorite_events?dev=m&view=l", {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        // Сохраняем полученные данные
        this.events = response.data;

        // Убираем класс после того, как данные получены
        mainPage.classList.remove('load');

      } catch (error) {
        if (axios.isCancel(error)) {
          // Обработка отмены запроса, если нужно
        } else {
          console.error('Ошибка при получении мероприятий:', error);
        }
      } finally {
        // Очистим таймер, если загрузка завершилась раньше 2 секунд
        clearTimeout(loadingTimeout);
      }
    },

    getImgUrl(posterName) {
      return `/api/pis/v1/images/posters/${posterName}`;
    },
    closePopup() {
      this.isPopupVisible = false;
      document.querySelector('html').classList.remove('animShowPopup');
      window.scrollTo(0, this.scrollPosition);
      setTimeout(() => {
        document.querySelector('html').classList.remove('showPopup');
      }, 500);


    },

    initMap() {
      if (this.selectedEvent && this.selectedEvent.point &&
        this.selectedEvent.point.latitude && this.selectedEvent.point.longitude) {
        const latitude = this.selectedEvent.point.latitude;
        const longitude = this.selectedEvent.point.longitude;
        var screenWidth = window.innerWidth;
        var iconImageSize;
        if (screenWidth < 640) {
          iconImageSize = [30, 42];
        } else if (screenWidth < 1600) {
          iconImageSize = [35, 50];
        } else {
          iconImageSize = [61, 88];
        }
        try {
          setTimeout(() => {
            const myMap = new ymaps.Map(this.$refs.mapContainer, {
              center: [latitude, longitude],
              zoom: 15
            });

            const placemark = new ymaps.Placemark([latitude, longitude], {
              hintContent: 'Место проведения мероприятия'
            }, {
              iconLayout: 'default#image',
              iconImageHref: metka3,
              iconImageSize: iconImageSize,
            });

            myMap.geoObjects.add(placemark);
          }, 100);
        } catch (error) {
          console.error("Error initializing Yandex Map:", error);
        }
      }
    },
    async deleteFav(event, item) {
      event.stopPropagation();

      const userInfo = JSON.parse(localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo'));

      if (!userInfo) {
        this.showLoginModal = true;
        return;
      }

      try {
        const config = {
          headers: {
            'X-API-KEY': 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1',
            'Content-Type': 'application/json'
          }
        };

        // Удаление из избранного
        const response = await axios.post(
          `/api/pis/v1/for_account/not_favorite?event_id=${item.id}`,
          {},
          config
        );

        // Успешно удалено из избранного
        if (response.status === 200) {
          // Удаляем item из events
          this.events = this.events.filter(event => event.id !== item.id);
        }
      } catch (error) {
        console.error('Ошибка при добавлении/удалении избранного:', error);
      }
    },
    getDayDifference(startTime, finishTime) {
      // Преобразование в объекты дат
      const startDate = new Date(startTime);
      const finishDate = new Date(finishTime);

      const userTimezoneOffset = startDate.getTimezoneOffset() / 60 * -1;

      startDate.setHours(startDate.getHours() + 4);
      finishDate.setHours(finishDate.getHours() + 4);

      // Вычисление разницы в миллисекундах
      const timeDiff = finishDate - startDate;
      const dayDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

      return dayDiff > 0 ? '+' + dayDiff : '';
    },
    formatDate(start, end) {
      const months = [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
      ];

      const startDate = new Date(start);
      const endDate = new Date(end);

      const userTimezoneOffset = startDate.getTimezoneOffset() / 60 * -1

      startDate.setHours(startDate.getHours() + 4)
      endDate.setHours(endDate.getHours() + 4)


      const day = startDate.getDate();
      const month = months[startDate.getMonth()];
      const hours = startDate.getHours().toString().padStart(2, '0');
      const minutes = startDate.getMinutes().toString().padStart(2, '0');

      const endHours = endDate.getHours().toString().padStart(2, '0');
      const endMinutes = endDate.getMinutes().toString().padStart(2, '0');

      return `${day} ${month}, ${hours}:${minutes} - ${endHours}:${endMinutes}`;
    },
    formatDateTime(start, end) {
      const months = [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
      ];

      const date = new Date(start);
      const endDate = new Date(end);

      const userTimezoneOffset = date.getTimezoneOffset() / 60 * -1

      date.setHours(date.getHours() + 4)
      endDate.setHours(endDate.getHours() + 4)

      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      const endHours = endDate.getHours().toString().padStart(2, '0');
      const endMinutes = endDate.getMinutes().toString().padStart(2, '0');

      return `${hours}:${minutes}-${endHours}:${endMinutes}`;
    },
    formattedDescr(description) {
      let formattedDescription = description.replace(/\n/g, '<br>');
      return formattedDescription;
    },
    formatDateTimeForPopup(startTime, endTime) {
      const days = [
        'Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'
      ];
      const months = [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
      ];

      const start = new Date(startTime);
      const end = new Date(endTime);

      // День недели, день и месяц
      const dayOfWeek = days[start.getDay()];
      const day = start.getDate();
      const month = months[start.getMonth()];

      // Время начала и окончания
      const startHours = start.getHours().toString().padStart(2, '0');
      const startMinutes = start.getMinutes().toString().padStart(2, '0');
      const endHours = end.getHours().toString().padStart(2, '0');
      const endMinutes = end.getMinutes().toString().padStart(2, '0');

      // Формируем строки времени и даты отдельно
      const timeString = `${startHours}:${startMinutes} - ${endHours}:${endMinutes}`;
      const dateString = `${dayOfWeek}, ${day} ${month}`;

      // Возвращаем объект с разделёнными строками
      return { time: timeString, date: dateString };
    },
    formatDatePopup(timestamp) {
      const months = [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
      ];

      const date = new Date(timestamp);
      const day = date.getDate();
      const month = months[date.getMonth()];

      return `${day} ${month}`;
    },
    formatTimePopup(startTime, endTime) {
      const start = new Date(startTime);
      const end = new Date(endTime);

      const userTimezoneOffset = start.getTimezoneOffset() / 60 * -1

      start.setHours(start.getHours() + 4)
      end.setHours(end.getHours() + 4)

      const startHours = start.getHours().toString().padStart(2, '0');
      const startMinutes = start.getMinutes().toString().padStart(2, '0');

      const endHours = end.getHours().toString().padStart(2, '0');
      const endMinutes = end.getMinutes().toString().padStart(2, '0');

      return `${startHours}:${startMinutes} - ${endHours}:${endMinutes}`;
    },
    formatShortDate(start) {
      const months = [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
      ];

      const shortMonths = [
        'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн',
        'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'
      ];

      const date = new Date(start);
      const day = date.getDate();
      const shortMonth = shortMonths[date.getMonth()];

      return `<b>${day}</b>${shortMonth}`; // Оборачиваем day в <b>
    },

  },
  mounted() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo'));
    if (!userInfo) {
      this.$router.push({ path: '/login' });
    }
    this.fetchEvents();

  }

};
</script>